<template>
  <div class="layout">
    <Header />
    <router-view />
    <el-backtop>
      <i class="el-icon-arrow-up"></i>
    </el-backtop>
  </div>
</template>

<script>
import Header from './components/header.vue'
export default {
  name: 'layout',
  components: { Header },
  props: [],
  data() {
    return {}
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.layout {
  width: 100%;
  .el-backtop {
    color: white;
    background-color: rgba(0,0,0,.6);
    border-radius: 2px;
    box-shadow: 0 1px 3px rgb(0 0 0 / 20%);
    transition: all .2s ease-in-out;
    i {
      font-weight: bold;
    }
  }
}
</style>